// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import AssetHeaderBreadcrumb from "./AssetHeaderBreadcrumb";
import AssetCreateDocumentPopup from "./AssetCreateDocumentPopup";

// Internal Imports
import { checkAssetPermission } from "../method";
import { EVENTS } from "../../../constants";
import { GlobalUtils, AmplitudeUtils } from "../../../utils";
import AssetHeaderSearch from "./AssetHeaderSearch";

// Actions Imports
import { toggleAssetDocumentView } from "../../../actions/AssetActions/assetActions";

// Destructuring
const { readDataFromLocalStorage, removeDataFromLocalStorage } = GlobalUtils;
const { amplitudeLogEvent } = AmplitudeUtils;

class AssetHeader extends Component {
  state = {
    newDocumentPopup: false,
  };

  componentDidMount() {
    // SHOW CREATE DOC POPUP ONCE AFTER USER HAS SIGNED UP
    const showPopUp = readDataFromLocalStorage("displayCreateDocPopUP");
    if (showPopUp) {
      this.setState({ newDocumentPopup: true }, () => {
        removeDataFromLocalStorage("displayCreateDocPopUP");
      });
    }

    // This code is responsible for clearing tab options when google sheet Filed
    const clickedTabItem = readDataFromLocalStorage("clickedTabItem");
    if (clickedTabItem) {
      removeDataFromLocalStorage("clickedTabItem");
      removeDataFromLocalStorage("lastDocPath");
    }
  }

  toggleNewDocumentPopup = () => {
    this.setState(
      prevState => ({ newDocumentPopup: !prevState.newDocumentPopup }),
      () => {
        if (!this.state.newDocumentPopup) {
          amplitudeLogEvent(EVENTS.EVENT_NAMES.CREATE_DOC_CLICKED, {
            initiatedFrom: "Asset",
          });
        }
      },
    );
  };

  _resetAssetDocumentView = () => {
    this.props.toggleAssetDocumentView("all");
  };

  render() {
    const { newDocumentPopup } = this.state;
    const {
      assetBreadcrumbData,
      currentFolderID,
      currentSelectedFolder,
      showSearchPage,
      toggleSearchPage,
      currentView,
    } = this.props;

    // let folderName = "-";
    // const isCRMFolder = false;
    // if (assetBreadcrumbData && assetBreadcrumbData.length > 0) {
    //   const {
    //     // name,
    //     opportunity_id: oppId,
    //     opportunity_root: oppRoot,
    //   } = assetBreadcrumbData[assetBreadcrumbData.length - 1];
    //   if (oppId && oppRoot) {
    //     isCRMFolder = true;
    //   }
    //   // if (name === "All") {
    //   //   folderName = "All Documents";
    //   } else {
    //     folderName = name;
    //   }
    // }

    let hasCreatePermission = true;
    if (currentSelectedFolder) {
      const { id, accessLevel } = currentSelectedFolder;
      if (id !== null) {
        const createType = accessLevel === "EDIT" ? "CREATE" : null;
        hasCreatePermission = checkAssetPermission(accessLevel, createType);
      }
    }

    return (
      <Fragment>
        <div className="assetheader-container">
          {/* ------------- Searchbar Header Section ------------- */}
          {/* <div className="assetheader-searchbar-wrapper"> */}
          {/* <div className="assetheader-searchbar">
              <AssetHeaderSearch />
            </div>
            {hasEditPermission && (
              <Button
                className="createdropdown-btn"
                onClick={this.toggleNewDocumentPopup}>
                CREATE DOCUMENT &nbsp;
              </Button>
            )} */}
          {/* <CreateDropdown newDocumentPopup={this.toggleNewDocumentPopup} /> */}
          {/* </div> */}

          {/* ------------- Item Details / Breadcrumb Header Section ------------- */}
          <div className="assetheader-detailsheader-wrapper">
            <div
              className="assetheader-itemheader-section"
              // className={
              //   showSearchPage
              //     ? "assetheader-hide-breadcrumb"
              //     : "assetheader-itemheader-section"
              // }
            >
              {/* {isCRMFolder ? (
                <span className="assetheader-itemheader-icon">
                  <Fragment>
                    <FontAwesomeIcon icon={["fas", "folder"]} />
                    <FontAwesomeIcon
                      icon={["far", "link"]}
                      className="link-icon"
                    />
                  </Fragment>
                </span>
              ) : (
                ""
              )} */}
              {/* ---------- Asset Header Breadcrumb section ---------- */}
              {/* <div className="assetheader-detailsheader-wrapper"> */}
              <div
                className={`assetheader-itemheader-details ${
                  assetBreadcrumbData && assetBreadcrumbData.length > 1
                    ? ""
                    : "all-documents"
                }`}>
                {/* <span className="assetheader-itemheader-title">
                  {folderName}
                </span> */}
                <span>
                  <AssetHeaderBreadcrumb
                    assetBreadcrumbData={assetBreadcrumbData}
                    currentFolderID={currentFolderID}
                    className="assetheader-breadcrumb"
                    resetAssetDocumentView={this._resetAssetDocumentView}
                  />
                  {/* {assetBreadcrumbData.length === 1 && (
                    <div className="assetheaderbreadcrumb-subtitle">
                      {currentView === "all"
                        ? "Documents and folders shared with you or created by you are listed here"
                        : "Only the documents that you have created are listed here"}
                    </div>
                  )} */}
                </span>
              </div>
            </div>
            {/* </div> */}
            {/* Asset Search */}
            <div className="assetheader-searchbar">
              <AssetHeaderSearch
                showSearchPage={showSearchPage}
                toggleSearchPage={toggleSearchPage}
              />
            </div>
            {/* ---------- Asset Create document button section ---------- */}
            <div className="assetheader-itemheader-profile">
              <div className="assetheader-btns">
                {hasCreatePermission && (
                  <Button
                    className="createdropdown-btn"
                    data-test="asset-create-document-btn"
                    onClick={this.toggleNewDocumentPopup}>
                    <i>
                      <FontAwesomeIcon icon={["far", "plus"]} />
                    </i>
                    Create document
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="assetheader-titlesection">
          <div className="assetheader-detailsheader-wrapper">
            {/* <div
              className={`assetheader-itemheader-details ${
                assetBreadcrumbData && assetBreadcrumbData.length > 1
                  ? ""
                  : "all-documents"
              }`}> */}
            {/* <span className="assetheader-itemheader-title">
                  {folderName}
                </span> */}
            {/* <span className="assetheader-itemheader-breadcrumb">
                <AssetHeaderBreadcrumb
                  assetBreadcrumbData={assetBreadcrumbData}
                  currentFolderID={currentFolderID}
                  className="assetheader-breadcrumb"
                  resetAssetDocumentView={this._resetAssetDocumentView}
                /> */}
            {assetBreadcrumbData.length === 1 && (
              <div className="assetheaderbreadcrumb-subtitle">
                {currentView === "all"
                  ? "Find documents and folders created by you or shared with you here"
                  : "Only the documents that you have created are listed here"}
              </div>
            )}
            {/* </span> */}
          </div>
          {/* </div> */}
        </div>

        {/* ---------- Asset Create document popup section ---------- */}
        {newDocumentPopup && (
          <AssetCreateDocumentPopup
            isOpen={newDocumentPopup}
            source="assets"
            togglePopup={this.toggleNewDocumentPopup}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    assetBreadcrumbData,
    currentFolderID,
    currentSelectedFolder,
    currentView,
  } = state.AssetStore;
  return {
    assetBreadcrumbData,
    currentFolderID,
    currentSelectedFolder,
    currentView,
  };
};

const mapDispatchToProps = {
  toggleAssetDocumentView,
};

AssetHeader.propTypes = {
  showSearchPage: PropTypes.bool.isRequired,
  toggleSearchPage: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetHeader);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetHeader/index.js